
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.92 46.13V13.79A1.79 1.79 0 0046.13 12H13.79A1.79 1.79 0 0012 13.79v32.34c0 .989.801 1.79 1.79 1.79h32.34a1.79 1.79 0 001.79-1.79z","stroke":"currentColor","stroke-width":"2","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M23.85 20.78c0 1.32-.97 2.39-2.58 2.39-1.51 0-2.48-1.07-2.48-2.39s1.01-2.39 2.54-2.39 2.48 1.04 2.51 2.39h.01zm-4.93 19.64V25.05h4.78v15.37h-4.78zM26.55 29.96c0-1.92-.06-3.52-.13-4.9h4.15l.22 2.14h.09c.63-1.01 2.17-2.48 4.74-2.48 3.14 0 5.5 2.11 5.5 6.63v9.08h-4.78v-8.52c0-1.98-.69-3.33-2.42-3.33-1.32 0-2.1.91-2.45 1.79-.13.31-.16.75-.16 1.19v8.86h-4.78V29.96h.02z","fill":"currentColor"}})])
          )
        }
      }
    